<template>
  <header class="app-header">
    <div class="left-wrap">
      <h1 v-if="title">{{ title }}</h1>
    </div>

    <div class="riht-wrap">
      <button type="button" class="close-page-btn" @click="handleClose">
        <img :src="getAssetImageUrl('common/icons/close.svg')" alt="" />
      </button>
    </div>
  </header>
</template>

<script setup lang="ts">
import { setIsBack } from '@/router';
import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

const props = withDefaults(
  defineProps<{
    title?: string;
    onClose?: () => void;
  }>(),
  {
    title: '',
  }
);
const emits = defineEmits(['close']);

const router = useRouter();

const handleClose = async () => {
  if (props.onClose) {
    emits('close');
  } else {
    setIsBack(true);
    router.back();
  }
};
</script>

<style scoped lang="scss">
.close-page-btn {
  padding: 0.25rem;
}
</style>
